import React from 'react';

import {
  VirtualTableColumnCellsEnum,
  VirtualTableSortableColumnDirectionsEnum,
} from '../../../../../../../../../src/components/common/table/helpers/tableHelpers';
import {
  DynamicTableColumn,
  SortableTableColumn,
  TableColumn,
} from '../../../../../../../../../src/components/common/table/tableColumn';
import {CustomFieldsEnum} from '../../../../../../../../../src/models/api/customFieldModel';
import {Trans} from '../../../../../../../../shared/helpers/src/internationalization/react';
import {VisualSizesEnum} from '../../../../../../../../shared/ui/src/styles/commonStyles';

/*
 * Constants.
 */

const accountsTableAccountColumnId = 'accounts-manager-account';
const accountsTableNonNameWidth = 208;

export enum AccountsTableColumnsEnum {
  DESCRIPTION = 'description',
  DYNAMIC = 'dynamic',
  NAME = 'name',
}

export const accountsTableColumns: ReadonlyArray<TableColumn<AccountsTableColumnsEnum>> = [
  {
    id: accountsTableAccountColumnId,
    title: <Trans id="accounts-manager-account-name">Name</Trans>,
    type: AccountsTableColumnsEnum.NAME,
    cellType: VirtualTableColumnCellsEnum.ACCOUNT,
    settings: {
      sticky: {
        isSticky: true,
      },
      cellWidth: {
        shouldFillRemainingWidth: true,
        minWidth: 330,
        maxWidth: 330,
      },
      loading: {
        avatarSize: VisualSizesEnum.LARGE,
      },
    },
  },
  {
    id: 'accounts-manager-account-description',
    title: <Trans id="accounts-manager-account-description">Description</Trans>,
    type: AccountsTableColumnsEnum.DESCRIPTION,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        width: accountsTableNonNameWidth,
      },
    },
  },
];

export const accountContactsTableDynamicColumns: ReadonlyArray<DynamicTableColumn<AccountsTableColumnsEnum>> =
  [
    {
      type: AccountsTableColumnsEnum.DYNAMIC,
      cellType: VirtualTableColumnCellsEnum.TEXT,
      settings: {
        cellWidth: {
          width: accountsTableNonNameWidth,
        },
      },
    },
    {
      type: AccountsTableColumnsEnum.DYNAMIC,
      cellType: VirtualTableColumnCellsEnum.INBOX,
      settings: {
        cellWidth: {
          width: accountsTableNonNameWidth,
        },
      },
    },
    {
      type: AccountsTableColumnsEnum.DYNAMIC,
      cellType: VirtualTableColumnCellsEnum.TEAMMATE,
      settings: {
        cellWidth: {
          width: accountsTableNonNameWidth,
        },
        loading: {
          avatarSize: VisualSizesEnum.SMALL,
        },
      },
    },
    {
      type: AccountsTableColumnsEnum.DYNAMIC,
      cellType: VirtualTableColumnCellsEnum.DATE,
      settings: {
        cellWidth: {
          width: accountsTableNonNameWidth,
        },
      },
    },
  ];

export const accountsTableSortableColumns: ReadonlyArray<SortableTableColumn> = [
  {
    id: accountsTableAccountColumnId,
    directions: [
      VirtualTableSortableColumnDirectionsEnum.ASCENDING,
      VirtualTableSortableColumnDirectionsEnum.DESCENDING,
    ],
  },
];

export function mapAccountIdToSortableColumnName(id: string | undefined) {
  if (id === accountsTableAccountColumnId) {
    return 'name';
  }
  return undefined;
}

/*
 * Helpers.
 */

export const getDynamicColumnConfigFromCustomFieldType = (customFieldType: CustomFieldsEnum) => {
  switch (customFieldType) {
    case CustomFieldsEnum.INBOX:
      return accountContactsTableDynamicColumns.find(
        (col) => col.cellType === VirtualTableColumnCellsEnum.INBOX,
      );
    case CustomFieldsEnum.TEAMMATE:
      return accountContactsTableDynamicColumns.find(
        (col) => col.cellType === VirtualTableColumnCellsEnum.TEAMMATE,
      );
    case CustomFieldsEnum.DATETIME:
      return accountContactsTableDynamicColumns.find(
        (col) => col.cellType === VirtualTableColumnCellsEnum.DATE,
      );
    case CustomFieldsEnum.BOOLEAN:
    case CustomFieldsEnum.STRING:
    default:
      return accountContactsTableDynamicColumns.find(
        (col) => col.cellType === VirtualTableColumnCellsEnum.TEXT,
      );
  }
};
